var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "43px",
    viewBox: "0 0 42 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7F314577-A3BB-46EB-9084-C0FE1D73A6A0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Administrador-Pearson",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u27054.1-Desktop-HD/-mapa-abierto--Copy-46",
    transform: "translate(-345.000000, -520.000000)",
    fill: "#007FA3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(345.000000, 520.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4,0 C39.4927946,0 42,2.5072054 42,5.6 L42,36.4 C42,39.4927946 39.4927946,42 36.4,42 L5.6,42 C2.5072054,42 0,39.4927946 0,36.4 L0,5.6 C0,2.5072054 2.5072054,0 5.6,0 L36.4,0 Z M36.4,2.1 L5.6,2.1 C3.71787171,2.1 2.18272732,3.5856147 2.10323366,5.44817726 L2.1,5.6 L2.1,36.4 C2.1,38.2821283 3.5856147,39.8172727 5.44817726,39.8967663 L5.6,39.9 L36.4,39.9 C38.2821283,39.9 39.8172727,38.4143853 39.8967663,36.5518227 L39.9,36.4 L39.9,5.6 C39.9,3.71787171 38.4143853,2.18272732 36.5518227,2.10323366 L36.4,2.1 Z",
    id: "Rectangle",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(8.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2506053,0 C17.8219157,0 21.5282368,3.67829327 21.5282368,8.21550552 C21.5282368,11.0988689 20.0314374,13.6353574 17.7670489,15.1013961 C23.0530396,16.2901964 27,20.9821521 27,26.5894917 C27,27.3684939 26.3637731,28 25.5789474,28 C24.7941217,28 24.1578947,27.3684939 24.1578947,26.5894917 C24.1578947,21.71459 20.2354006,17.7495115 15.352078,17.6339458 L15.1327895,17.6313536 L11.8672105,17.6313536 C6.88256254,17.6313536 2.84210526,21.6418303 2.84210526,26.5894917 C2.84210526,27.3684939 2.20587833,28 1.42105263,28 C0.636226934,28 0,27.3684939 0,26.5894917 C0,21.1104945 3.76834978,16.5054577 8.87293009,15.1884539 C6.53174921,13.7384679 4.97368421,11.1575908 4.97368421,8.21550552 C4.97368421,3.67820397 8.67938483,0 13.2506053,0 Z M13.2506053,2.82101657 C10.2490362,2.82101657 7.81578947,5.2362084 7.81578947,8.21550552 C7.81578947,11.1948026 10.2490362,13.6099945 13.2506053,13.6099945 C16.2523554,13.6099945 18.6861316,11.1946229 18.6861316,8.21550552 C18.6861316,5.23638811 16.2523554,2.82101657 13.2506053,2.82101657 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.9ec19da128152a9dca6e7fa83ef4e4d3.svg";
export { ForwardRef as ReactComponent };